<script>
  import { onMount } from 'svelte';
  import { format } from 'svelte-i18n';
  import { Button, Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  export let params = [];
  export let defaultConfig = [];

  const ALWAYS_HIDDEN_NAMES = ['password'];

  const isAlwaysHidden = (name) => !!name && ALWAYS_HIDDEN_NAMES.some((entry) => name.toLowerCase().includes(entry));

  const addParam = () => {
    params.push({
      name: '',
      value: '',
      hidden: false
    });

    params = [...params];
  };

  const removeParam = (index) => {
    params.splice(index, 1);
    params = [...params];
  };

  onMount(() => {
    if (defaultConfig.length) {
      defaultConfig.forEach((param) => {
        params.push({
          name: param.name,
          value: param.value,
          hidden: param.hidden
        });
      });
    }
  });
</script>

<div class="parameters framed">
  {#each params as param, index}
    {@const alwaysHidden = isAlwaysHidden(param.name)}
    <div class="parameter columns">
      <input type="text" placeholder={$format('label.NAME')} class="name" bind:value={param.name} />

      {#if alwaysHidden || param.hidden}
        <input type="password" placeholder={$format('label.VALUE')} class="value" bind:value={param.value} />
      {:else}
        <input type="text" placeholder={$format('label.VALUE')} class="value" bind:value={param.value} />
      {/if}

      <Icon
        name={alwaysHidden || param.hidden ? 'eye-off' : 'eye'}
        id="param-value-{index}-hide"
        class="pointer text-medium {alwaysHidden ? 'opacity-50' : ''}"
        role="button"
        tabindex="0"
        on:click={() => {
          if (!alwaysHidden) {
            param.hidden = !param.hidden;
          }
        }}
      />

      <Tooltip target="param-value-{index}-hide" class="tooltip" placement="top">
        {alwaysHidden
          ? $format('label.TOOLTIP.PLUGIN_PARAMETER_ALWAYS_HIDDEN')
          : $format('label.TOOLTIP.PLUGIN_PARAMETER_CHECKBOX')}
      </Tooltip>

      <Icon name="trash" class="pointer" role="button" tabindex="0" on:click={() => removeParam(index)} />
    </div>
  {/each}
  <Button color="secondary" class={params.length ? 'mt-3' : ''} size="sm" on:click={addParam}>
    <Icon name="plus" />
    <span>{$format('label.PARAMETER')}</span>
  </Button>
</div>

<style lang="scss" src="./plugin-parameters.scss"></style>
